import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { PaymentMethodComponent } from './payment-method.component';
import { LFDropdownModule } from '../../../../shared/dropdown/dropdown.module';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';

@NgModule({
    imports: [
        SharedModule,
        LFDropdownModule.forRoot(),
        MatCheckboxModule,
    ],
    declarations: [PaymentMethodComponent],
    exports: [PaymentMethodComponent],
})
export class PaymentMethodModule
{
}
